import { RefreshCw } from "lucide-react";

interface ResaleLoopProps {
  wornCount: number;
  compact?: boolean;
}

export function ResaleLoop({ wornCount, compact = false }: ResaleLoopProps) {
  const emojis = ["💃", "👗", "✨"];

  if (compact) {
    return (
      <div className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs border border-border/60 bg-muted/40">
        <RefreshCw size={10} style={{ color: "var(--rose)" }} />
        <span className="text-muted-foreground">Worn {wornCount}× across {wornCount} event{wornCount > 1 ? "s" : ""}</span>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-border/60 p-4" style={{ background: "var(--rose-light)" }}>
      <div className="flex items-center gap-2 mb-2">
        <RefreshCw size={15} style={{ color: "var(--rose)" }} />
        <span className="text-sm font-semibold" style={{ color: "var(--rose)" }}>Resale Loop</span>
      </div>
      <p className="text-sm text-foreground/80 mb-3">
        This dress has been worn <strong>{wornCount} time{wornCount > 1 ? "s" : ""}</strong> across {wornCount} event{wornCount > 1 ? "s" : ""} 💃
      </p>
      <div className="flex items-center gap-1">
        {Array.from({ length: Math.min(wornCount, 5) }).map((_, i) => (
          <div
            key={i}
            className="w-7 h-7 rounded-full border-2 border-white flex items-center justify-center text-sm"
            style={{ background: "var(--blush)", marginLeft: i > 0 ? "-6px" : 0 }}
          >
            {emojis[i % emojis.length]}
          </div>
        ))}
        <span className="text-xs text-muted-foreground ml-2">
          {wornCount > 1 ? `${wornCount} happy buyers` : "Be the next owner!"}
        </span>
      </div>
    </div>
  );
}
